import {Component, forwardRef, Input, OnChanges, OnInit} from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
  FormGroup
} from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatOptionModule } from '@angular/material/core';
import {TypesService, FormBuilderService, ClientService} from '../../../services';
import {
  IndividualRelationshipModel,
  PreviousAddressModel,
  IndividualPhoneModel,
  IndividualPersonModel,
  IndividualNasPhoneModel, IndividualNonApplicantModel
} from '../../../models/widgets/personal-details-model';
import {
  notSameEmailValidator,
  noSameValues,
  notSameMobileNumbersValidator,
  notSameCompanyRelationShipValidator,
  borrowerGuarantorValidator,
} from '../../../_global/validators/custom-validators.directive';
import _ from 'lodash';
import {debounceTime, take, takeUntil} from 'rxjs/operators';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import * as moment from 'moment';
import {DataHandlerService} from '../../../services/data-handler.service';
import {
  CustomValidator,
  defaultFieldConfig
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';
import { BehaviorSubject } from 'rxjs';
import { AddressSuggestionsComponent } from '../address-suggestions/address-suggestions.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgFor, NgIf, NgClass } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import {
  DateTextComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/date-text/date-text.component';
import {
  SensisEmailComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-email/sensis-email.component';
import {
  SensisMobileComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-mobile/sensis-mobile.component';
import {
  AddressSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/address-search/address-search.component';
import {
  FurtherAdvanceConfirmationComponent
} from '../further-advance-confirmation/further-advance-confirmation.component';

@Component({
    selector: 'app-personal-details',
    templateUrl: 'personal-details.component.html',
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-AU' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
    ],
    standalone: true,
  imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, NgFor, NgIf, MatFormFieldModule,
    MatFormFieldModule, MatSelectModule, MatSelectModule, MatOptionModule, MatOptionModule, MatButtonModule,
    MatButtonModule, MatIconModule, MatInputModule, MatInputModule, ValidationPartialComponent, NgClass,
    MatCheckboxModule, MatCheckboxModule, forwardRef(() => AddressSuggestionsComponent), DateTextComponent,
    SensisEmailComponent, SensisMobileComponent, AddressSuggestionsComponent, AddressSearchComponent, FurtherAdvanceConfirmationComponent]
})

export class PersonalDetailsComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public isPersonalLoan: any;
  @Input() public isHomeLoan: any;
  @Input() public personList: any;
  @Input() public applicationType: any;
  @Input() public trustList: any;
  @Input() public companyList: any;
  @Input() public borrowerType: any;
  @Input() public borrowerCount: any;
  @Input() public brokerDetails: any;
  @Input() public faType: string;
  @Input() public checkNonApplicantValidation = false;
  @Input() public isSmsf = false;
  @Input() public isFurtherAdvance = false;

  public detailsConfirmed = false;
  public personFormArray: any;
  public currentFormGroupState: any;
  public appHasNonApplicant = false;
  public homeAddressInvalid = false;
  public showQldFields = false;
  public showVicFields = false;
  public bwr1PreviousAddressLength = 0;
  public maritalStatusTypesSlug = 'marital-statuses-vx';
  public maritalStatusTypes = [];
  public residencyTypesSlug = 'residency-types-vx';
  public residencyTypes: any;
  public relationshipTypesSlug = 'vx-hem-relationship';
  public relationshipTypes = [];
  public borrowerGuarantorTypesSlug = 'borrower-guarantor-types';
  public borrowerGuarantorTypes = [];
  public phoneTypesSlug = 'telephone-types-vx';
  public phoneTypes = [];
  public australianStateTypes = [];
  public australianStateTypesSlug = 'australian-state-types';

  public idvTitle = 'Person';
  public hasCrumbsPermission = false;

  public acceptedPhoneTypes = {
    'mobile': ['MOBILE']
  };

  // reject mobile numbers
  public rejectedPhoneTypes = {
    'fax': ['MOBILE'],
    'fixed': ['MOBILE'],
  };


  constructor(private typesService: TypesService,
              private clientService: ClientService,
              private formBuilderService: FormBuilderService,
              public dataHandlerService: DataHandlerService) {
    super(dataHandlerService);
  }

  ngOnInit() {

    super.ngOnInit();
    this.populateResidencyTypes();
    this.populateMaritalStatus();
    this.populateBorrowerGuarantor();
    this.populatePhoneTypes();
    this.populateAustralianStateTypes();

    this.handleChanges();

    this.populateRelationships();
    this.reloadPersonListValidation();

    setTimeout(() => {
      this.checkValidators();
    }, 2000);

    this.dataHandlerService.getSmsfData()
      .subscribe((value: any) => {
        if (this.isHomeLoan) {
          if (value) {
            this.formGroup.get('personList').clearValidators();
          } else if (this.applicationType !== 'new-personal') {
            this.formGroup.get('personList').clearValidators();
          } else {
            this.reloadPersonListValidation();
            this.formGroup.get('personList').addValidators(
              Validators.compose([
                borrowerGuarantorValidator()
              ])
            );
          }
          this.formGroup.get('personList').updateValueAndValidity();
        }
      });

    setTimeout(() => {
      this.dataHandlerService.getBorrowerCountData()
        .subscribe((value: any) => {
          if (this.isSmsf) {
            const personListCount = this.personFormArray.controls.length;
            if (value !== null || value !== undefined) {
              if (personListCount > value) {
                const countDiff = personListCount - value;

                for (let i = personListCount; i > countDiff; i--) {
                  this.personFormArray.removeAt(i - 1);
                }
              }
            }
          }
        });
    }, 5000);

  }

  ngOnChanges(changes) {
    this.personFormArray = this.formGroup.get('personList');

    if (changes['applicationType'] && this.applicationType !== 'new-personal') {
      this.reloadPersonListValidation(changes['applicationType'].currentValue);
    } else if (changes['applicationType'] && changes['applicationType'].previousValue !== null && this.applicationType === 'new-personal') {
      this.personFormArray.controls.forEach((formGroup: any, index: number) => {
        formGroup.get('borrowerGuarantor').patchValue('borrower');
      });
    }

    if (changes['borrowerType']) {
      this.borrowerType = changes['borrowerType'].currentValue;

      if (this.borrowerType === 'company') {
        this.idvTitle = 'Director';
        this.checkCompanyValidation();
        this.formGroup.get('personList').clearValidators();
      } else {
        this.idvTitle = 'Person';
      }

      if (changes['borrowerType'].currentValue !== changes['borrowerType'].previousValue && changes['borrowerType'].currentValue === 'individual-with-non-applicant') {
        if (this.personFormArray && this.personFormArray.length > 1) {
          this.personFormArray.controls.forEach((formGroup: UntypedFormGroup, index: number) => {
            if (!this.isFurtherAdvance && index > 0) {
              this.personFormArray.removeAt(index);
            }
          });
        }

        this.appHasNonApplicant = true;
        this.addNonApplicantSpouse();
        this.populateRelationships();
      } else if (changes['borrowerType'].currentValue !== changes['borrowerType'].previousValue && changes['borrowerType'].currentValue === 'joint-individual') {
        if (changes['borrowerType'].previousValue === 'individual-with-non-applicant') {
          this.appHasNonApplicant = false;
          const nasFormGroupIndex = this.personFormArray.value.findIndex(x => x.nonApplicant);
          if (!this.isFurtherAdvance && nasFormGroupIndex > -1) {
            this.personFormArray.removeAt(nasFormGroupIndex);
          }
        }
        this.populateRelationships();
      } else {
        this.appHasNonApplicant = false;
        this.populateRelationships();
      }
    }

    if (changes['brokerDetails'] && this.brokerDetails && this.isHomeLoan) {
      this.clientService.retrieveBrokers(this.brokerDetails.id)
        .subscribe((broker: any) => {
          if (broker.allowExistingCreditEnquiryID) {
            this.hasCrumbsPermission = true;
          } else {
            this.hasCrumbsPermission = false;
          }
        });
    }

    if (changes.isPersonalLoan &&
      changes.isPersonalLoan.currentValue === true &&
      changes.isPersonalLoan.previousValue === false) {
      // remove all company relationships
      _.each(this.personFormArray.controls, c => c.removeControl('companyRelationships'));
    }

    this.reloadPersonListValidation();
  }

  broadcastPersonList(index) {
    this.dataHandlerService.sendApplicantForRemoval(index);
  }

  checkValidators() {
    if (this.isHomeLoan) {
      this.personFormArray.controls.forEach((person: any) => {
        if (person && person.get('driversLicenceState') && person.get('driversLicenceCardNumber')) {
          person.get('driversLicenceState').clearValidators();
          person.get('driversLicenceState').updateValueAndValidity();
          person.get('driversLicenceCardNumber').clearValidators();
          person.get('driversLicenceCardNumber').updateValueAndValidity();

          this.checkIdValidation(person.get('driversLicenceState').value, person);
        }
      });
    } else {
      this.personFormArray.controls.forEach((person: any) => {
        if (person && person.get('driversLicenceState')) {
          this.checkIdValidation(person.get('driversLicenceState').value, person);
        }
      });
    }
  }

  checkCompanyValidation() {
    this.formGroup.get('personList').clearValidators();
  }

  checkValidationNonApplicant() {
    this.personFormArray.value.forEach((value: any, index: number) => {

      if (value.nonApplicant) {
        this.appHasNonApplicant = true;
        this.personFormArray.controls.at(index).get('email').clearValidators();
        this.personFormArray.controls.at(index).get('email').setValidators(Validators.email);
        this.personFormArray.controls.at(index).get('email').updateValueAndValidity();

        const findRelationshipIndex = this.relationshipTypes.findIndex(x => x.id === 'couple-with-applicant');
        if (findRelationshipIndex >= 0) {
          this.relationshipTypes.splice(findRelationshipIndex, 1);
        }

        this.personFormArray.controls.at(0).get('relationships').at(0).get('type').patchValue('couple-with-non-applicant', {emitEvent: false});
      }
    });
  }

  handleChanges() {
    this.personFormArray.valueChanges
      .pipe(debounceTime(300))
      .subscribe((val: any, index: number) => {
        if (!_.isMatch(this.currentFormGroupState, val)) {
          this.currentFormGroupState = val;

          this.processAddressDuplication(val);
          this.computeLengthOfStays(val);
          this.initPhones();
          this.initRelationships();
          this.checkValidationNonApplicant();
        }
      });
  }

  checkLicenceValidation(formGroup) {
    if (formGroup.get('driversLicence').value && !this.isHomeLoan) {
      formGroup.get('driversLicenceState').setValidators(Validators.required);
      formGroup.get('driversLicenceState').updateValueAndValidity();
    } else {
      formGroup.get('driversLicenceState').clearValidators();
      formGroup.get('driversLicenceState').updateValueAndValidity();
    }
  }

  computeLengthOfStays(data) {
    for (let i = 0; i < data.length; i++) {
      if (data[i]['stayAtHomeYears'] != null || data[i]['stayAtHomeMonths'] != null) {
        // compute length of stay on home address
        const minMonths = 24;
        const previousAddresses = data[i]['previousAddresses'] || [];
        const _stayAtHome = (data[i]['stayAtHomeYears'] * 12) + data[i]['stayAtHomeMonths'];
        let _stayAtPrev = 0;
        let _prevTreshold = 0;
        previousAddresses.forEach((prevAdd, idx) => {
          if ((_stayAtHome + _stayAtPrev) >= minMonths && !_prevTreshold) {
            _prevTreshold = idx;
          }
          _stayAtPrev += (prevAdd['stayAtPrevYears'] * 12) + prevAdd['stayAtPrevMonths'];
        });
        const fg = this.personFormArray.at(i) as UntypedFormGroup;
        const prevFa: UntypedFormArray = fg.get('previousAddresses') ? fg.get('previousAddresses') as UntypedFormArray : new UntypedFormArray([]);

        // remove all addresses that are over the limit
        if (_prevTreshold && _prevTreshold < prevFa.length) {
          while (_prevTreshold < prevFa.length) {
            prevFa.removeAt(prevFa.length - 1);
          }
        }
        if (_stayAtHome + _stayAtPrev >= 0 && _stayAtHome + _stayAtPrev < minMonths) {
          // create another previous address if all time at address is filled up
          if (!previousAddresses.find(pa => !pa['stayAtPrevYears'] && !pa['stayAtPrevMonths'])) {
            const prevAddress = new PreviousAddressModel();
            const prevFg = this.formBuilderService.convertObjectToFormGroup(prevAddress);
            this.formBuilderService.setValidationRules(new PreviousAddressModel(), prevFg);
            prevFa.push(prevFg);

            if (!fg.get('previousAddresses')) {
              fg.addControl('previousAddresses', prevFa);
            }
          }
        } else if (_stayAtHome >= minMonths && fg.get('previousAddresses')) {
          // remove all previous addresses
          fg.removeControl('previousAddresses');
        }

      }

      this.bwr1PreviousAddressLength = (this.personFormArray.controls.at(0).get('previousAddresses') && this.personFormArray.controls.at(0).get('previousAddresses').controls.length > 0) ? this.personFormArray.controls.at(0).get('previousAddresses').controls.length : 0;
    }
  }

  triggerAddressValidationUpdates(fg, addressToCopy) {
    if (fg && fg.value) {
      if (fg.value.isPoBox !== addressToCopy.isPoBox) {
        const isPoBoxFC = fg.get('isPoBox');
        if (isPoBoxFC) {
          isPoBoxFC.patchValue(addressToCopy.isPoBox);
          isPoBoxFC.updateValueAndValidity();
        }
      }
      if (fg.value.isManualEntry !== addressToCopy.isManualEntry) {
        const isManualEntryFC = fg.get('isManualEntry');
        if (isManualEntryFC) {
          isManualEntryFC.patchValue(addressToCopy.isManualEntry);
          isManualEntryFC.updateValueAndValidity();
        }
      }
    }
  }

  updatePostSettlementValidation(ev, formGroup) {
    if (ev.checked) {
      formGroup.get('postSettlementAddress').controls.flatSearch.clearValidators();
      formGroup.get('postSettlementAddress').controls.flatSearch.updateValueAndValidity();
    } else {
      formGroup.get('postSettlementAddress').controls.flatSearch.setValidators([Validators.required]);
      formGroup.get('postSettlementAddress').controls.flatSearch.updateValueAndValidity();
    }
  }

  addressAsBorrower1(ev, formGroup, fieldName, prevAddrFormGroup?) {
    if (ev.checked && fieldName === 'residentialAddressSameAsBorrower1') {
      if (formGroup.value.homeAddress.isManualEntry !== this.personFormArray.controls.at(0).get('homeAddress').value.isManualEntry) {
        formGroup.get('homeAddress').get('isManualEntry').patchValue(this.personFormArray.controls.at(0).get('homeAddress').value.isManualEntry);
      }

      formGroup.patchValue({'homeAddress': this.personFormArray.controls.at(0).get('homeAddress').value}, {emitEvent: false});
      formGroup.patchValue({'residencyType': this.personFormArray.controls.at(0).get('residencyType').value}, {emitEvent: false});
      formGroup.patchValue({'stayAtHomeYears': this.personFormArray.controls.at(0).get('stayAtHomeYears').value}, {emitEvent: false});
      formGroup.patchValue({'stayAtHomeMonths': this.personFormArray.controls.at(0).get('stayAtHomeMonths').value}, {emitEvent: false});
      formGroup.get('homeAddress').updateValueAndValidity();
    } else if (!ev.checked && fieldName === 'residentialAddressSameAsBorrower1') {
      // formGroup.patchValue({'homeAddress': null}, {emitEvent: false});
      formGroup.get('homeAddress').reset({emitEvent: false});
      formGroup.patchValue({'residencyType': ''}, {emitEvent: false});
      formGroup.patchValue({'stayAtHomeYears': ''}, {emitEvent: false});
      formGroup.patchValue({'stayAtHomeMonths': ''}, {emitEvent: false});
    } else if (ev.checked && fieldName === 'previousAddressSameAsBorrower1') {
      formGroup.get('previousAddresses').controls.forEach((previousAddress: any, index: number) => {
        if (previousAddress.value.previousAddressSameAsBorrower1 ) {
          if (previousAddress.value.previousAddress.isManualEntry !== this.personFormArray.controls.at(0).get('previousAddresses').controls.at(index).value.previousAddress.isManualEntry) {
            previousAddress.get('previousAddress').get('isManualEntry').patchValue(this.personFormArray.controls.at(0).get('previousAddresses').at(index).value.previousAddress.isManualEntry); // need this to trigger change of validators properly
          }

          previousAddress.patchValue({'previousAddress': this.personFormArray.controls.at(0).get('previousAddresses').at(index).get('previousAddress').value}, {emitEvent: false});
          previousAddress.patchValue({'prevResidencyType': this.personFormArray.controls.at(0).get('previousAddresses').at(index).value.prevResidencyType}, {emitEvent: false});
          previousAddress.patchValue({'stayAtPrevYears': this.personFormArray.controls.at(0).get('previousAddresses').at(index).value.stayAtPrevYears}, {emitEvent: false});
          previousAddress.patchValue({'stayAtPrevMonths': this.personFormArray.controls.at(0).get('previousAddresses').at(index).value.stayAtPrevMonths}, {emitEvent: false});
        }
      });
    } else if (!ev.checked && fieldName === 'previousAddressSameAsBorrower1') {
      for (const [key, value] of Object.entries(prevAddrFormGroup.get('previousAddress').controls)) {
        prevAddrFormGroup.get('previousAddress').get(key).patchValue('', {emitEvent: false});
      }

      prevAddrFormGroup.patchValue({'prevResidencyType': ''}, {emitEvent: false});
      prevAddrFormGroup.patchValue({'stayAtPrevYears': ''}, {emitEvent: false});
      prevAddrFormGroup.patchValue({'stayAtPrevMonths': ''}, {emitEvent: false});
    }

    this.computeLengthOfStays(this.personFormArray.value);
  }

  processAddressDuplication(data) {
    for (let i = 0; i < data.length; i++) {
      const fg = this.personFormArray.at(i);
      if (data[i].homeAddress) {
        if (data[i].postalAddressAsHome) {
          this.triggerAddressValidationUpdates(fg.get('postalAddress'), data[i].homeAddress);
          fg.patchValue({'postalAddress': data[i].homeAddress}, {emitEvent: false});
        }
        if (data[i].postSettlementAddressAsHome) {
          this.triggerAddressValidationUpdates(fg.get('postSettlementAddress'), data[i].homeAddress);
          fg.patchValue({'postSettlementAddress': data[i].homeAddress}, {emitEvent: false});
        }
      }
    }
  }

  populateResidencyTypes() {
    this.typesService.getTypesList(this.residencyTypesSlug)
      .then(results => {
        this.residencyTypes = _.sortBy(_.filter(results, ['ext.Active', true]), 'ext.SortOrder');
      });
  }

  populateMaritalStatus() {
    this.typesService.getTypesList(this.maritalStatusTypesSlug)
      .then(results => {
        results.filter(res => {
          if (res.ext.Active === true) {
            this.maritalStatusTypes.push(res);
          }
        });
      });
  }

  handleLinkedPersons(from, to) {
    // update the matched person
    // find all other relationships linked to this person or linked to the target person
    const linkedPersons = this.personFormArray.controls.filter(c => {
      return c.value.relationships.find(rel => rel.to === from || (rel.to === to && rel.from !== from));
    });

    linkedPersons.forEach(personControl => {
      personControl.get('relationships').at(0).patchValue({
        type: 'single',
        to: null
      });
    });

    if (to) {
      const person = this.personFormArray.at(to - 1);
      person.get('relationships').at(0).patchValue({
        type: 'couple-with-applicant',
        from: to,
        to: from
      });
    }
  }

  populateRelationships() {

    this.relationshipTypes = [];
    this.typesService.getTypesList(this.relationshipTypesSlug)
      .then(results => {
        results.forEach((res: any, index: number) => {
          switch (res.id) {
            case 'single':
            case '7':
              res['msg'] = 'single';
              res['slug'] = 'single';
              break;

            case 'couple-with-applicant':
            case '8':
              res['msg'] = 'in a relationship with';
              res['slug'] = 'couple-with-applicant';
              break;

            case 'couple-with-non-applicant':
            case '9':
              res['msg'] = 'in relationship but not with any of the borrowers';
              res['slug'] = 'couple-with-non-applicant';
              break;
          }

          if (this.relationshipTypes.findIndex(x => x.id === res.id) === -1) {
            this.relationshipTypes.push(res);
          }

          if (res.slug === 'couple-with-applicant' && this.borrowerType === 'individual') {
            const foundRelationshipTypeIndex = this.relationshipTypes.findIndex(x => x.slug === 'couple-with-applicant');
            if (foundRelationshipTypeIndex > -1) {
              this.relationshipTypes.splice(foundRelationshipTypeIndex, 1);
            }
          }
        });
      });
    this.personFormArray.value.forEach((p, idx) => {
      this.addRelationship(idx);
    });
  }

  initRelationships() {
    this.personFormArray.value.forEach((p, i) => {
      if (!p.relationships || p.relationships.length === 0) {
        this.addRelationship(i);
      }
    });
  }

  initPhones() {
    this.personFormArray.controls.forEach((person, i) => {
      if (!person.value.phones || person.value.phones.length === 0) {
        this.addPhone(i);
      } else {
        _.get(person, 'controls.phones.controls', []).forEach((fg: UntypedFormGroup) => {
          fg.get('phoneNumber').setValidators(Validators.compose([Validators.required, Validators.pattern('[0-9+]*')]));

          fg.updateValueAndValidity({emitEvent: false});

          if (person.get('nonApplicant') && person.get('nonApplicant').value) {
          }
        });
      }
      // set validators
      person.get('phones').setValidators(noSameValues('phoneNumber'));
    });
  }

  addPhone(index, data = null) {
    const formarray = this.personFormArray.at(index).get('phones') as UntypedFormArray || new UntypedFormArray([]);

    let phone: any;
    if (this.personFormArray.at(index).get('nonApplicant') && this.personFormArray.at(index).get('nonApplicant').value) {
      phone = new IndividualNasPhoneModel();
    } else {
      phone = new IndividualPhoneModel();
    }

    const fg = this.formBuilderService.convertObjectToFormGroup(phone);
    if (data) {
      fg.patchValue(data);
    }
    formarray.push(fg);
    if (!this.personFormArray.at(index).get('phones')) {
      this.personFormArray.at(index).setControl('phones', formarray, {emitEvent: false});
    }
  }

  deletePhone(personIndex, phoneIndex) {
    const formarray = this.personFormArray.at(personIndex).get('phones');
    if (phoneIndex !== 0) {
      formarray.removeAt(phoneIndex);
    }
  }

  addRelationshipToCompany(fromIndex, formArray) {
    if (!formArray) {
      const fa = new UntypedFormArray([]);

      if (!this.isSmsf) {
        fa.setValidators(Validators.compose([notSameCompanyRelationShipValidator()]));
      }


      if (this.borrowerType !== 'individual-with-non-applicant') {
        this.personFormArray.at(fromIndex).setControl('companyRelationships', fa);
      }

      formArray = fa;
    }
    const relationship = new IndividualRelationshipModel();
    relationship.from.value = fromIndex;
    relationship.type.value = null;
    relationship.to.value = null;
    const fg = this.formBuilderService.convertObjectToFormGroup(relationship);
    fg.get('type').setValidators([Validators.required]);
    fg.get('to').setValidators([Validators.required]);
    this.formBuilderService.setValidationRules(new IndividualRelationshipModel(), fg);
    formArray.push(fg);
  }

  addRelationship(index) {
    if (!this.personFormArray.at(index).get('nonApplicant')) {
      let existing: any = {};
      if (this.personFormArray.at(index).get('relationships') && this.personFormArray.at(index).get('relationships').value && this.personFormArray.at(index).get('relationships').value.length > 0) {
        existing = this.personFormArray.at(index).get('relationships').at(0).value;
      }

      const formarray = new UntypedFormArray([]);
      const fromId = index + 1;
      const relationship = new IndividualRelationshipModel();
      relationship.from.value = fromId;
      relationship.type.value = existing.type || null;
      relationship.to.value = existing.to || null;
      const fg = this.formBuilderService.convertObjectToFormGroup(relationship);

      const setValidators = (type) => {
        if (type === 'couple-with-applicant') {
          fg.get('to').setValidators([Validators.required]);
        } else {
          const linkedPersons = this.personFormArray.controls.filter(c => c.value.relationships && c.value.relationships.find(rel => rel.to === fromId));
          if (linkedPersons.length > 0) {
            linkedPersons.forEach(personControl => {
              const relationshipCtrl = personControl.get('relationships').at(0);
              relationshipCtrl.patchValue({
                type: 'single',
                to: null
              }, {emitEvent: false});
              relationshipCtrl.get('to').reset();
              relationshipCtrl.get('to').clearValidators();
              relationshipCtrl.get('to').updateValueAndValidity();
            });
          }
          fg.get('to').reset();
          fg.get('to').clearValidators();
          fg.get('to').updateValueAndValidity();
        }
      };

      fg.get('type').valueChanges.subscribe(val => {
        setValidators(val);
      });
      setValidators(relationship.type.value);

      this.formBuilderService.setValidationRules(new IndividualRelationshipModel(), fg);
      formarray.push(fg);
      this.personFormArray.at(index).setControl('relationships', formarray);
    }
  }

  hasExistingRelationship(from, to) {
    return !!this.personFormArray.controls.find(c => c.value && c.value.relationships && c.value.relationships.find(rel => rel.to === to && rel.from !== from));
  }

  populateBorrowerGuarantor() {
    if (this.isHomeLoan) {
      this.typesService.getTypesList(this.borrowerGuarantorTypesSlug)
        .then((results) => {
          this.borrowerGuarantorTypes = results;
        });
    }
  }

  clearPrivacyConsent() {
    this.personFormArray.controls.forEach((formGroup: any) => {
      if (formGroup.get('privacyConsent')) {
        formGroup.get('privacyConsent').patchValue(false);
      }
    });
  }

  populatePhoneTypes() {
    this.typesService.getTypesList(this.phoneTypesSlug)
      .then((results) => {
        this.phoneTypes = _.filter(results, ['ext.Active', true]);
      });
  }

  populateAustralianStateTypes() {
    this.typesService.getTypesList(this.australianStateTypesSlug)
      .then((results) => {
        this.australianStateTypes = results;
      });
  }

  checkIdValidation(value: any, formGroup) {
    if (value) {
      const state: any = this.australianStateTypes.find(x => x.ext.Slug === value);
      formGroup.get('licenceStateCode')?.setValue(state.text);
      formGroup.get('driversLicence').updateValueAndValidity();

      const qldValidationDate = moment('31/12/2022', 'DD/MM/YYYY');
      const vicValidationDate = moment('14/12/2022', 'DD/MM/YYYY');
      this.showQldFields = (moment().isAfter(qldValidationDate, 'day'));
      this.showVicFields = (moment().isAfter(vicValidationDate, 'day'));

      if (!this.isHomeLoan){
        if (state && state.text === 'QLD' && !moment().isAfter(qldValidationDate, 'day')) {
          formGroup.get('driversLicenceCardNumber').clearValidators();
          formGroup.get('driversLicenceCardNumber').patchValue(null);
          formGroup.get('driversLicenceCardNumber').setErrors(null);
          formGroup.get('driversLicenceCardNumber').updateValueAndValidity();
        } else if (state && state.text === 'VIC' && !moment().isAfter(vicValidationDate, 'day')) {
          formGroup.get('driversLicenceCardNumber').clearValidators();
          formGroup.get('driversLicenceCardNumber').patchValue(null);
          formGroup.get('driversLicenceCardNumber').setErrors(null);
          formGroup.get('driversLicenceCardNumber').updateValueAndValidity();
        } else {
          formGroup.get('driversLicenceCardNumber').setValidators(Validators.compose(
            [Validators.required, CustomValidator.driversLicenceValidator(defaultFieldConfig.driversLicenceCardNumber, [], 'licenceStateCode')]));
          formGroup.get('driversLicenceCardNumber').updateValueAndValidity();
        }
      }
    }
  }

  addNewIndividual() {
    console.log('addNewIndividual');
    const addPersonModel = new IndividualPersonModel();
    const indivFg = this.formBuilderService.convertObjectToFormGroup(addPersonModel);
    this.formBuilderService.setValidationRules(new IndividualPersonModel(), indivFg);
    this.personList.push(indivFg);
    this.reloadPersonListValidation();
    if (!this.isPersonalLoan) {
      this.addRelationshipToCompany(this.personList.length - 1, null);
    }
  }

  addNonApplicantSpouse() {
    if (!this.isFurtherAdvance || this.isFurtherAdvance && this.personList.length < 2) {
      console.log('addNonApplicantSpouse');
      const addNasModel = new IndividualNonApplicantModel();
      const indivFg = this.formBuilderService.convertObjectToFormGroup(addNasModel);
      this.formBuilderService.setValidationRules(new IndividualNonApplicantModel(), indivFg);
      this.personList.push(indivFg);

      if (!this.isPersonalLoan) {
        this.addRelationshipToCompany(this.personList.length - 1, null);
      }
    }
  }
  /**
   * reload/reapply the `personList` form group validations
   */
  reloadPersonListValidation (applicationType: string = this.applicationType) {
    if (this.isFurtherAdvance) {
      this.personFormArray.controls.forEach((fg: any, index: number) => {
        console.log('reloadPersonListValidation ::: formGroup', fg);
        const rawValues = fg.getRawValue();
        if (rawValues && !rawValues.partyRoleId && !rawValues.firstName && !rawValues.lastName) {
          fg.get('firstName').enable({emitEvent: false});
          fg.get('middleName').enable({emitEvent: false});
          fg.get('lastName').enable({emitEvent: false});
        } else {
          fg.get('firstName').disable({emitEvent: false});
          fg.get('middleName').disable({emitEvent: false});
          fg.get('lastName').disable({emitEvent: false});
        }

        if (fg.get('dateOfBirth')) {
          fg.get('dateOfBirth').clearValidators({emitEvent: false});
          fg.get('dateOfBirth').clearAsyncValidators({emitEvent: false});
          fg.get('dateOfBirth').updateValueAndValidity({emitEvent: false});
        }

        console.log('reloadPersonListValidation', fg);
      });
    }

    // to support auto loan or home loan with "new-personal" application type only.
    if (!this.isHomeLoan || (this.isHomeLoan && applicationType === 'new-personal')) {
      const personList = this.formGroup.get('personList');
      personList.clearValidators();
      personList.setValidators(
        Validators.compose([
          notSameEmailValidator(),
          notSameMobileNumbersValidator()
        ])
      );
      personList.updateValueAndValidity();
    }
  }
}
